import React from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANT from './../../constant';
import { getDateParts } from '../../utils';
import ModalWindow from './../common/ModalWindow';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            showModal: false,
            selectedEmployee: null
        };
    }

    render() {
        const { list } = this.props;
        const { showModal, selectedEmployee } = this.state;

        return (
            <>
                <table className="tablen">
                    <thead>
                        <tr className='text-center'>
                            <th className="table-dark">Employee #</th>
                            <th className="table-dark">Name</th>
                            <th className="table-dark">Department</th>
                            <th className="table-dark">Designation</th>
                            <th className="table-dark">Unit</th>
                            <th className="table-dark">Is HOD?</th>
                            <th className="table-dark">Last Updated</th>
                            <th className="table-dark">APAR Details</th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            list === undefined &&
                            <tr>
                                <td colSpan={8} className="text-center">Loading...</td>
                            </tr>
                        }

                        {
                            list !== undefined && list.length === 0 &&
                            <tr>
                                <td colSpan={8} className="text-center">No records found</td>
                            </tr>
                        }

                        {
                            list !== undefined && list.map((item: any) => {
                                const editPageURL = CONSTANT.component.adminEditUser.url.replace(':code', item.code);
                                const dated = getDateParts(item.modifiedOn);

                                return (
                                    <tr
                                        key={item.code}
                                       
                                    >
                                        <td>{item.employeeNumber}</td>
                                        <td>{item.name}</td>
                                        <td>{item.departmentName}</td>
                                        <td>{item.designationName}</td>
                                        <td>{item.unitName}</td>

                                        <td>
                                            {item.isHOD
                                                ? <i className="fa fa-check-circle text-success" />
                                                : <i className="fa fa-times-circle text-danger" />}
                                        </td>

                                        <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>

                                        <td className="text-center">
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.openAparModal(item);
                                                }}
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>

                {/* APAR Sections Modal */}
                {showModal && selectedEmployee && (
                    <ModalWindow 
                        title={`APAR Sections - ${selectedEmployee.name} (${selectedEmployee.employeeNumber})`}
                        toggleModal={this.closeModal}
                    >
                        <div className="apar-sections-modal">

                            <div className="row">

                                {/* Reporting & Reviewing Authority */}
                                <div className="col-md-6 mb-3">
                                    <div 
                                        className="card h-100 apar-section-card c-pointer"
                                        onClick={() => this.navigateToSection('reporting-authority', selectedEmployee.code)}
                                    >
                                        <div className="card-body text-center d-flex flex-column justify-content-between">
                                            <div>
                                                <i className="fa fa-users fa-3x text-primary mb-3"></i>
                                                <h5 className="card-title">Reporting & Reviewing Authority</h5>
                                            </div>

                                            <button className="btn btn-sm btn-primary mt-3 align-self-center">
                                                View Details <i className="fa fa-arrow-right ml-1"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Period of Absence */}
                                <div className="col-md-6 mb-3">
                                    <div 
                                        className="card h-100 apar-section-card c-pointer"
                                        onClick={() => this.navigateToSection('period-of-absence', selectedEmployee.code)}
                                    >
                                        <div className="card-body text-center d-flex flex-column justify-content-between">
                                            <div>
                                                <i className="fa fa-calendar-times-o fa-3x text-warning mb-3"></i>
                                                <h5 className="card-title">Period of Absence on Leave</h5>
                                            </div>

                                            <button className="btn btn-sm btn-primary mt-3 align-self-center">
                                                View Details <i className="fa fa-arrow-right ml-1"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Qualifications & Training (Merged Section) */}
                                <div className="col-md-6 mb-3">
                                    <div 
                                        className="card h-100 apar-section-card c-pointer"
                                        onClick={() => this.navigateToSection('qualifications-training', selectedEmployee.code)}
                                    >
                                        <div className="card-body text-center d-flex flex-column justify-content-between">
                                            <div>
                                                <i className="fa fa-graduation-cap fa-3x text-success mb-3"></i>
                                                <h5 className="card-title">Qualifications & Training</h5>
                                            </div>

                                            <button className="btn btn-sm btn-primary mt-3 align-self-center">
                                                View Details <i className="fa fa-arrow-right ml-1"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Other Details */}
                                <div className="col-md-6 mb-3">
                                    <div 
                                        className="card h-100 apar-section-card c-pointer"
                                        onClick={() => this.navigateToSection('other-details', selectedEmployee.code)}
                                    >
                                        <div className="card-body text-center d-flex flex-column justify-content-between">
                                            <div>
                                                <i className="fa fa-file-text-o fa-3x text-secondary mb-3"></i>
                                                <h5 className="card-title">Other Details</h5>
                                               
                                            </div>

                                            <button className="btn btn-sm btn-primary mt-3 align-self-center">
                                                View Details <i className="fa fa-arrow-right ml-1"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </ModalWindow>
                )}
            </>
        )
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }

    openAparModal = (employee: any) => {
        this.setState({
            showModal: true,
            selectedEmployee: employee
        });
    }

    closeModal = () => {
        this.setState({
            showModal: false,
            selectedEmployee: null
        });
    }

    navigateToSection = (section: string, employeeCode: number) => {
        this.closeModal();

        const sectionUrls: any = {
            'reporting-authority': CONSTANT.component.aparReportingAuthority.url,
            'period-of-absence': CONSTANT.component.aparPeriodOfAbsence.url,
            'qualifications-training': CONSTANT.component.aparQualificationsTraining.url,
            'other-details': CONSTANT.component.aparOtherDetails.url
        };

        const url = sectionUrls[section].replace(':code', employeeCode);
        this.props.history.push(url);
    }
}

export default withRouter(ComponentName);
